import { render, staticRenderFns } from "./staffAdd.vue?vue&type=template&id=4d35762e&scoped=true"
import script from "./staffAdd.vue?vue&type=script&lang=js"
export * from "./staffAdd.vue?vue&type=script&lang=js"
import style0 from "./staffAdd.vue?vue&type=style&index=0&id=4d35762e&prod&scoped=true&lang=css"
import style1 from "./staffAdd.vue?vue&type=style&index=1&id=4d35762e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d35762e",
  null
  
)

export default component.exports